import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { INTEGRATION_CONFIG_SELECT_FIELD_OPTIONS_KEY } from '@/utils/queryKeys.ts';

import { SelectOption } from '@/types/integrations.ts';

export type SelectFieldOptionsPayload = {
  step_id: string;
  field_id: string;
  options: SelectOption[];
};

const useInvalidateIntegrationSelectFieldOptions = (automationId: string) => {
  const queryClient = useQueryClient();

  return useCallback(
    (payload: SelectFieldOptionsPayload): undefined => {
      const stepId = payload.step_id;
      const fieldId = payload.field_id;
      const options = payload.options;
      queryClient.setQueryData<SelectOption[]>(
        INTEGRATION_CONFIG_SELECT_FIELD_OPTIONS_KEY(automationId, stepId, fieldId),
        options,
      );
      return undefined;
    },
    [automationId, queryClient],
  );
};

export default useInvalidateIntegrationSelectFieldOptions;
